import { render, staticRenderFns } from "./pgStatusGraph.vue?vue&type=template&id=4cd8c29e&"
import script from "./pgStatusGraph.vue?vue&type=script&lang=js&"
export * from "./pgStatusGraph.vue?vue&type=script&lang=js&"
import style0 from "./pgStatusGraph.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports